import { all, fork } from 'redux-saga/effects';
import DevicesSaga from './devices-saga';
import UserSaga from './user-saga';
import DeviceTelemetrySaga from './device-telemetry-saga';

export default function* rootSaga(): Generator {
  yield all([fork(DevicesSaga), fork(UserSaga), fork(DeviceTelemetrySaga)]);
}
